export const getFullscreenElement = jest.fn();
export const enterFullscreen = jest.fn();
export const exitFullscreen = jest.fn();
export const notifyFullscreenChange = jest.fn();
